import ParisSocietyLogo from '../../../../assets/logos/paris-society.png'
import RikasLogo from '../../../../assets/logos/rikas.png'
import { Tenant } from '../../../../models/Tenant'

const tenants: Tenant[] = [
  {
    envName: 'ps',
    name: 'Paris Society',
    logo: ParisSocietyLogo,
    platforms: {
      ios: {
        identifier: 'com.paris-society.paris-society',
        appId: '1620406969',
      },
      android: {
        identifier: 'com.parissociety.parissociety',
      },
      whatsapp: { identifier: 'Paris Society' },
    },
    appCenterBaseUrl: 'https://paris-society.app',
    app: {
      tabs: [
        { name: 'Home', value: '/home' },
        { name: 'NON MEMBER - Bars', value: '/bars' },
        { name: 'NON MEMBER - Hotels', value: '/hotels' },
        { name: 'NON MEMBER - Membership showcase', value: '/membership' },
        { name: 'MEMBER - Events', value: '/events' },
        { name: 'MEMBER - Concierge', value: '/concierge' },
        { name: 'MEMBER - Benefits', value: '/benefits' },
        { name: 'Booking history', value: '/booking-history' },
        { name: 'Settings', value: '/settings' },
      ],
    },
    status: 'active',
  },
  {
    envName: 'rikas',
    name: 'Rikas',
    logo: RikasLogo,
    platforms: {
      ios: { identifier: 'com.rikas.rikas', appId: '6741322268' },
      android: { identifier: 'com.rikas.rikas' },
      whatsapp: { identifier: 'Rikas' },
    },
    appCenterBaseUrl: 'https://rikas.app',
    app: {
      tabs: [
        { name: 'Home', value: '/home' },
        { name: 'Beach Houses', value: '/beach-houses' },
        { name: 'Booking history', value: '/booking-history' },
        { name: 'Settings', value: '/settings' },
      ],
    },
    status: 'suspended',
  },
]

export { tenants }
